import { editBook } from "../actions";

const updateBook = (bookId, bookDetails) => {
  return async (dispatch) => {
    const response = await fetch(`http://localhost:9000/books/${bookId}`, {
      method: "PATCH",
      body: JSON.stringify({
        name: bookDetails.name,
        author: bookDetails.author,
        thumbnail: bookDetails.thumbnail,
        price: bookDetails.price,
        rating: bookDetails.rating,
        featured: bookDetails.featured,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    const book = await response.json();

    dispatch(editBook(bookId, book));
  };
};

export default updateBook;
